import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import BiReport from './BiReport';
import { hydrateDashboardFilter } from '../../../utils/dashboardFilterStorage';

const BIPage = () => {
  const { reportId } = useParams();
  const location = useLocation();
  const [viewportHeight, setViewportHeight] = useState(() => window.innerHeight);

  useEffect(() => {
    const handleResize = () => setViewportHeight(window.innerHeight);
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const reportHeight = Math.max(420, viewportHeight - 190);

  return (
    <div className="grid grid-cols-1 h-screen gap-2 p-4 bg-gray-100 mt-[-4rem] pt-[5rem]">
      <div className="col-span-1 overflow-hidden bg-white shadow sm:rounded-lg">
        <div className="h-full overflow-hidden  custom-scrollbar">
          <BiReport
            reportId={reportId}
            height={reportHeight}
            filter={
              location.state?.dashboardFilter ? hydrateDashboardFilter(location.state.dashboardFilter) : undefined
            }
            dashboardData={location.state?.dashboardData}
            dashboardView={false}
          />
        </div>
      </div>
    </div>
  );
};

export default BIPage;
